<template>
  <lists-page :suppression="false" />
</template>

<script>
import ListsPage from '@/modules/lists/pages/ListsPage'
export default {
  components: { ListsPage }
}
</script>



// WEBPACK FOOTER //
// src/modules/lists/pages/ListsPageUser.vue